<form
  class="quality-control-approvals-form"
  [formGroup]="qualityControlApprovalsFormGroup()"
>
  @for (field of qualityControlApprovalsFormFields; track $index) {
    @switch (field.type) {
      @case ('select') {
        <app-custom-mat-select
          [options]="approvalStatusSelectData()"
          [selectedValueId]="qualityControlApprovalData().approvalStatus"
          [label]="field.label"
          [fullWidth]="true"
          [isEditModeActive]="!this.qualityControlApprovalData().id || isEditModeActive()"
          [needEmptyValue]="false"
          (selectedChange)="handleSelectChange($event, field.fieldName)"
        />
      }
      @case ('textarea') {
        <mat-form-field
          appearance="outline"
          class="quality-control-approvals-form-field-textarea"
          [class]="getFieldClass()"
        >
          <mat-label>{{ field.label }}</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="3"
            [formControlName]="field.fieldName"
            (blur)="handleValueChange(field.fieldName)"
          ></textarea>
        </mat-form-field>
      }
    }
  }
  @if (!qualityControlApprovalData().id) {
    <div class="buttons-container">
      @if (noFirstData()) {
        <button
          mat-button
          color="warn"
          (click)="handleDeleteData()"
        >
          Удалить
        </button>
      }
      <button
        mat-button
        color="primary"
        [disabled]="qualityControlApprovalsFormGroup().invalid"
        (click)="handleCreateData()"
      >
        Сохранить
      </button>
    </div>
  }
</form>
